<div
  *ngIf="searchParams"
  class="atlas-form mct-gap-54 mct-grid mct-grid-lt-md mct-cols-auto-lt-md contact-record-search-grid"
>
  <div class="area-left" >
    <div class="mb-27 mct-flex mct-col mct-flex-1-1-0" >
      <label class="light-text">{{ 'contact-records.search.user' | translate | ucfirst }}</label>
      <input [(ngModel)]="searchParams.Contactee" />
    </div>
    <div class="mb-27">
      <label class="light-text">{{ 'contact-records.search.contact-date' | translate | titlecase }}</label>
      <div class="mct-flex mct-row mct-justify-center mct-items-center mct-gap-11"   >
        <wl-date-selector [(ngModel)]="searchParams.StartDate"></wl-date-selector>
        <span class="light-text">{{ 'contact-records.search.through' | translate }}</span>
        <wl-date-selector [(ngModel)]="searchParams.EndDate"></wl-date-selector>
      </div>
    </div>
    <div class="mct-flex mct-row" style="align-items: center;">
      <p-checkbox
        style="margin-bottom: 0; margin-right: 8px;"
        binary="true"
        [(ngModel)]="searchParams.IncludeContactsFromEmailTool"
        inputId="includeContactsFromEmailTool"
      >
      </p-checkbox>
      <label for="includeContactsFromEmailTool" style="margin-bottom: 0;">
        {{ 'contact-records.search.include-contacts-from-email-tool' | translate | ucfirst }}
      </label>
    </div>
  </div>

  <div class="area-right" >
    <div class="mb-27 mct-flex mct-col" >
      <label class="light-text">{{ 'contact-records.search.subject-keyword' | translate | titlecase }}</label>
      <input [(ngModel)]="searchParams.SubjectKeyword" />
    </div>
    <div class="mb-27 atlas-autocomplete">
      <label class="light-text">{{ 'contact-records.search.contact-types' | translate | titlecase }}</label>
      <p-autocomplete
        #autoComplete
        appendTo="body"
        optionLabel="ContactType"
        [(ngModel)]="selectedContactTypes"
        [multiple]="true"
        [suggestions]="contactTypesSearchResults"
        (completeMethod)="searchContactTypes($event)"
        (onSelect)="syncItems()"
        (onUnselect)="syncItems()"
      >
      </p-autocomplete>
    </div>
  </div>
</div>
